import { render, staticRenderFns } from "./jiaotong.vue?vue&type=template&id=7e4858e9&scoped=true&"
import script from "./jiaotong.vue?vue&type=script&lang=js&"
export * from "./jiaotong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4858e9",
  null
  
)

export default component.exports